import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import agm from '../../services/agm';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  ListItemText,
  Checkbox
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import Add from '@material-ui/icons/AddCircleOutline';
import { BiImport } from "react-icons/bi";

import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));
const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.cyan[400],
    '&$checked': {
      color: colors.cyan[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultDependencies = {
  loaded: false,
  regions: [],
  applications: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);

  const [region, setRegion] = useState(1);
  const [labelApplications, setLabelApplications] = useState([]);
  const [applicationSelecteds, setApplicationSelecteds] = useState([]);

  const [dependencies, setDependencies] = useState(defaultDependencies);


  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(
      event.target.value,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      region,
      applicationSelecteds);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(
      query,
      event.target.value,
      page,
      rows,
      startDateTime,
      endDateTime,
      region,
      applicationSelecteds);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(
      query,
      keyword,
      newPage,
      rows,
      startDateTime,
      endDateTime,
      region,
      applicationSelecteds);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rowsPerPage,
      rows,
      startDateTime,
      endDateTime,
      region,
      applicationSelecteds);
  };

  const changeRegion = (event) => {
    setRegion(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      event.target.value,
      applicationSelecteds);
  }

  const changeApplications = (event) => {
    var appls = [0];
    for (let indexA = 0; indexA < dependencies.applications.length; indexA++) {
      const elementA = dependencies.applications[indexA];
      for (let indexB = 0; indexB < event.target.value.length; indexB++) {
        const elementB = event.target.value[indexB];
        if (elementA.nome == elementB) {
          appls.push(elementA.id);
          labelApplications.push(elementA.nome);
        }
      }
    }
    setPage(0);
    setApplicationSelecteds(appls);
    setLabelApplications(event.target.value);
    changeFilter(
      query,
      keyword,
      page,
      rows,
      startDateTime,
      endDateTime,
      region,
      appls);
  }

  const loadDependencies = ((value) => {
    agm.get('/produtoslpu/filtro/-1', {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          regions: response.data.regioes,
          applications: response.data.aplicacoes
        });
        var appls = [];
        var lbappls = [];
        for (let index = 0; index < response.data.aplicacoes.length; index++) {
          const element = response.data.aplicacoes[index];
          appls.push(element.id);
          if (element.extra != 1)
            lbappls.push(element.nome);
        }
        const value = {
          pagina: page,
          registros: rows,
          palavrachave: keyword,
          visao: query,
          ativo: true,
          aplicacoes: appls,
          regiao: region
        }
        setApplicationSelecteds(appls);
        setLabelApplications(lbappls);
      } else {
        setDependencies(defaultDependencies);
      }
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    if (!dependencies.loaded) {
      loadDependencies({});
    }
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>LPU</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={1}>
                            <Grid item
                              md={2}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >

                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <TextField
                                fullWidth
                                disabled={!query.refine}
                                onChange={changeKeyword}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SvgIcon
                                        fontSize="small"
                                        color="action"
                                      >
                                        <SearchIcon />
                                      </SvgIcon>
                                    </InputAdornment>
                                  )
                                }}
                                placeholder={"Refinar pesquisa por, " + query.label}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid
                              item
                              md={2}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="region">Região</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Região"
                                  variant="outlined"
                                  id="region"
                                  name="region"
                                  value={region}
                                  onChange={changeRegion}
                                  inputProps={{
                                    name: 'region',
                                    id: 'region',
                                  }}
                                >
                                  {dependencies.regions.map((reg) => (
                                    <MenuItem key={reg.id} value={reg.id}>{reg.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={5}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="labelApplications">Aplicações</InputLabel>
                                <Select notched
                                  id="labelApplications"
                                  multiple
                                  value={labelApplications}
                                  onChange={changeApplications}
                                  fullWidth
                                  label="Aplicações"
                                  name="labelApplications"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'labelApplications',
                                    id: 'labelApplications',
                                  }}
                                >

                                  {dependencies.applications.map((item) => (
                                    <MenuItem key={item.id} value={item.nome} label={item.nome} >
                                      <ColorCheckbox checked={labelApplications.indexOf(item.nome) > -1} />
                                      <ListItemText primary={item.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={9}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={3}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justifyContent="baseline"
                  alignItems="flex-start"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED || localStorage.getItem('profile') != 'ENG'}
                          size="small"
                          variant="contained"
                          startIcon={<Add />}
                          onClick={() => { openCreation(item) }}>
                          Criar Item LPU
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Box mt={2} >
                      <Button
                        color="secondary"
                        disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED || true}
                        size="small"
                        variant="contained"
                        startIcon={<BiImport />}
                        onClick={() => { }}>
                        Importar
                      </Button>&nbsp;
                    </Box>

                  </Grid>

                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
